
import { transGet } from './transTools.js';

var notifyInterval;
export function notifyShutdownOff() {
    if (notifyInterval) clearInterval(notifyInterval);
    $('.update-notify-wr').remove();
};
export function notifyShutdown(html) {
    if (!$('.update-notify-wr').length) {
        if (html) {
            $('.wbouter').before(html);
        }
    }

    function updateCounters() {
        $('.seccounter').each(function () {
            var $this = $(this);
            var sec = parseInt($this.data('sec'), 10);
            var starttime, endtime;
            if (!$this.data('starttime')) {
                starttime = Date.now();
                endtime = starttime + (sec * 1000);
                $this.data('starttime', starttime);
                $this.data('endtime', endtime);
            } else {
                starttime = $this.data('starttime');
                endtime = $this.data('endtime');
            }
            sec = Math.round((endtime - Date.now()) / 1000);
            if (sec <= 60) {
                $('.update-notify-wr').addClass('urgent');
            }
            if (sec > 0) {
                sec -= 1;
                $this.data('sec', sec);

                var h = Math.floor(sec / 3600);
                var m = Math.floor((sec % 3600) / 60);
                var s = sec % 60;

                if ($this.hasClass('v2')) {
                    $this.text((h > 0 ? h + ':' : '') + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s);
                    return;
                }
                var display = '';
                if (h) {
                    display += h + (h == 1 ? ' ' + transGet('hour', 'h') : ' ' + transGet('hours', 'h'));
                } else if (m) {
                    display += m + (m == 1 ? ' ' + transGet('minute', 'm') : ' ' + transGet('minutes', 'm'));
                } else {
                    var s = sec - m * 60;
                    display += s + (s == 1 ? ' ' + transGet('second', 's') : ' ' + transGet('seconds', 's'));
                }
                $this.text(display);
            }
            if (sec <= 0) {
                $this.closest(".backtext").fadeOut();
                if (!$this.closest('.update-notify-wr').hasClass('off')) {
                    // reload page
                    location.reload();
                    return false;
                }
            }
        });
    }
    function saveStatus(on) {
        if (!on) {
            let myDate = new Date();
            myDate.setTime(myDate.getTime() + 60 * 60 * 1000); // 1 hour?
            document.cookie = 'updateNotify=1;expires=' + myDate + ';domain=.' + $('.update-notify-wr').data('domain') + ';path=/';
        } else {
            document.cookie = 'updateNotify=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.' + $('.update-notify-wr').data('domain') + ';path=/';
        }
    }

    if ($('.update-notify-wr').length) {
        notifyInterval = setInterval(updateCounters, 1000);
    }

    $('.update-notify-wr').on('click', '.close,.closeok', function (e) {
        $(this).closest('.update-notify-wr').addClass('closed');
        saveStatus(false);
        e.stopPropagation();
    });
    $('.update-notify-wr').on('click', function (e) {
        $(this).removeClass('closed');
        saveStatus(true);
    });
};
